<template>
  <div class="group group--contentful group--sidebar mt2">
    <p v-if="articles && articles.length && !loadingSearch" class="p mb mt50">{{ articles.length }} {{ articles.length > 1 ? `results` : `result` }} found:</p>

    <div v-for="article in articles" :key="article.id">
      <a
        v-if="article && !loadingSearch"
        class="link link--accent fw-bold p tdn"
        @click="navigateToArticle(article)"
      >
        {{ article.name }}
      </a>
      <!-- <pre>{{ article }}</pre> -->
    </div>

    <module-modal
      :modal="modalExternalData"
      v-show="showDisclaimer"
      @close="showDisclaimer = false"
    >

      <template slot="modal-footer">
        <module-button @click.native="showDisclaimer = false">No</module-button>
        <module-button @click.native="goToUrl">Yes</module-button>
      </template>
    </module-modal>

    <p v-if="!hasResults && !loadingSearch" class="p">0 results found - try adjusting your search terms of navigating by topic</p>

    <module-dots v-if="loadingSearch" :active="true" />
  </div>
</template>

<script>
// Vuex
import { mapGetters, mapActions } from 'vuex';

// Utils
import { toSlug } from 'utils/string';

// Modules
import ModuleModal from 'components/Modal';
import ModuleDots from 'components/Dots';

export default {
  name: 'view-search-results',

  components: {
    ModuleModal,
    ModuleDots,
  },

  data() {
    return {
      showDisclaimer: false,
      preUrl: null,
      modalExternalData: {
        title: 'You are now leaving the website.',
        copy: 'Your destination website is not controlled by our privacy statement. Please read the privacy statement of your destination website. Do you want to continue?',
      },
    };
  },

  // Computed
  computed: {
    ...mapGetters('app', ['org']),
    ...mapGetters('contentful', ['loadingSearch', 'topics', 'articles']),

    hasResults() {
      const searchQuery = this.$route.query.search && this.$route.query.search.length;
      return searchQuery && this.articles && this.articles.length;
    },
  },

  // Methods
  methods: {
    ...mapActions('contentful', ['getArticles', 'getTopics']),

    goToUrl() {
      window.open(this.preUrl, '_blank');
      this.showDisclaimer = false;
    },

    navigateToArticle(article) {
      const { externalUrl } = article;

      if (externalUrl && this.org.show_disclaimer) {
        this.showDisclaimer = true;
        this.preUrl = externalUrl;
      } else if (externalUrl && !this.org.show_disclaimer) {
        this.preUrl = externalUrl;
        this.goToUrl();
      } else {
        this.$router.push({
          name: 'article',
          params: {
            article: toSlug(article.name),
          },
          query: {
            ...this.$route.query,
            articleId: article.id,
          },
        });
      }
    },
  },

  // Lifecycles
  created() {
    if ( !this.$route.query.search ) this.$router.push({ name: 'topics' });

    this.$nextTick(() => {
      const searchInput = document.getElementById('search');
      if ( searchInput ) searchInput.focus();
    });
  },
};
</script>



// WEBPACK FOOTER //
// SearchResults.vue?509786f0